import { useState, useEffect } from 'react';

const calculateRange = (data, rowsPerPage) => {
  const range = [];
  const num = data && data.length > 0 ? Math.ceil(data.length / rowsPerPage) : 0;
  let i = 1;
  for (let i = 1; i <= num; i++) {
    range.push(i);
  }
  return range;
};

const sliceData = (data, page, rowsPerPage) => {
  return data && data.length > 0 ? data.slice((page - 1) * rowsPerPage, page * rowsPerPage) : [];
};

const useTable = (data, page, rowsPerPage) => {
  const [tableRange, setTableRange] = useState([]);
  const [slice, setSlice] = useState([]);

  useEffect(() => {
    const range = calculateRange(data, rowsPerPage);
    setTableRange([...range]);

    const slice = sliceData(data, page, rowsPerPage);
    setSlice([...slice]);
  }, [data, page]);

  return { slice, range: tableRange };
};

export default useTable;
